import { useQuery } from '@tanstack/react-query';
import { apiCall } from '@/lib/api-client';

export interface CallAttemptRow {
  id: string;
  assignmentId: string;
  clientId: string;
  cinHash: string;
  firstName: string;
  lastName: string;
  outcome: string;
  attemptedAt: string;
  notes: string | null;
  durationSec: number | null;
}

export function useCallAttempts(outcome: string | null = null, limit = 100) {
  const params = new URLSearchParams();
  if (outcome) params.set('outcome', outcome);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['agents', 'me', 'call-attempts', outcome, limit],
    queryFn: () => apiCall<CallAttemptRow[]>(`/agents/me/call-attempts?${params.toString()}`),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
